import { render, staticRenderFns } from "./post-list.vue?vue&type=template&id=437071fc&"
import script from "./post-list.vue?vue&type=script&lang=js&"
export * from "./post-list.vue?vue&type=script&lang=js&"
import style0 from "./post-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "post-list.vue"
export default component.exports